<template>
  <div class="doctorpc-apply-msg">
    <docpc-steps :current="stepActive"></docpc-steps>
    <div class="docpc-panel">
      <div class="docpc-msg msg-page">
        <div class="msg-hd">
          <div class="msg-png" style="height: auto;">
            <img :src="msg.png" alt="">
          </div>
        </div>
        <div class="msg-bd">
          <div class="title" v-if="msg.title" v-html="msg.title"></div>
          <div class="desc" v-if="msg.desc" v-html="msg.desc"></div>
        </div>
        <div class="msg-ft">
          <van-button v-for="(item, index) in msgButtons" :key="index" :color="item.color" round size="small" @click="item.onClick">
            {{item.txt}}</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import iconsuccess from "@/assets/docpc/icon_success.png"
import iconwarn from "@/assets/docpc/icon_warn.png"
import iconerror from "@/assets/docpc/icon_error.png"
import docpcSteps from "@/doctor_pc/components/steps/steps.vue"
import {
  mapState,
  mapActions
} from "vuex";
import {
  Toast,
} from "vant";
import {
  doctorGetDetail, syncErecipelDoctor
} from '@/api/doctorapi';
export default {
  name: 'docpcApplyMsg',
  components: {
    docpcSteps
  },
  data() {
    return {
      themeColor: 'linear-gradient(to bottom, #23C7C3, #07A7B4)',
      icon_success: iconsuccess,
      icon_warn: iconwarn,
      icon_error: iconerror,
      stepActive: null,
      doctor_info: null,
      msg: {
        png: iconsuccess,
        title: '',
        desc: ''
      },
      msgButtons: []
    }
  },
  computed: {
    ...mapState(['docpc']),
  },
  created() {
    this.msg.title = '提交成功'
    this.msg.desc = `尊敬的${this.docpc.docpcInfo.doctor.name}医生，您好。感谢您参与“择美同行-患者援助项目”，您的注册信息已递交至项目办进行审核，请您耐心等待，审核结果将会发送至您的手机上。感谢您的理解与支持！`
    this.msgButtons = [{
      txt: '确认',
      color: this.themeColor,
      onClick: this.toBlank.bind(this)
    }]
  },
  methods: {
    toBlank() {
      this.$router.replace({
        name: "docpcBlank",
      });
    },
  }
}
</script>

<style lang='less'>
</style>